import {
    AbstractControl,
    FormControl,
    FormGroup,
    FormGroupDirective,
    NgForm,
    ValidationErrors,
    ValidatorFn
} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

export class CustomValidators {
    static confirmPasswordMath(formGroup: FormGroup): ValidatorFn {
        return (): ValidationErrors | null => {
            const newPasswordControl = formGroup.get('newPassword');
            const confirmPasswordControl = formGroup.get('confirmPassword');
            if (!newPasswordControl || !confirmPasswordControl || !!newPasswordControl.invalid) {
                return null;
            }
            const isMatch = newPasswordControl.value === confirmPasswordControl.value;
            if (!isMatch) {
                return { notSame: true};
            }
            return null;
        };
    }

    static newPasswordNotSame(formGroup: FormGroup): ValidatorFn {
        return (): ValidationErrors | null => {
            const newPasswordControl = formGroup.get('newPassword');
            const currentPasswordControl = formGroup.get('oldPassword');
            if (!newPasswordControl || !currentPasswordControl ||
                !!newPasswordControl.invalid || !!currentPasswordControl.invalid) {
                return null;
            }
            const isMatch = newPasswordControl.value === currentPasswordControl.value;
            if (isMatch) {
                return { notSame: true};
            }
            return null;
        };
    }

    static newPasswordWhiteSpace(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control && control?.value?.match(/\s/g )) {
                return { whitespace: true };
            }
            return null;
        };
    }
}

export class ConfirmPasswordErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        control.updateValueAndValidity();
        if (control.value) {
            control.markAsTouched();
        }
        return control.invalid && (control.touched);
    }
}
